import {
  initializationMaskingZoneFillLayer,
  initializationMaskingZoneMarginLayer,
  initializationMaskingZoneMarginOutlineLayer,
  initializationMaskingZoneOutlineLayer,
  noFlyZoneFillLayer,
  noFlyZoneOutlineLayer,
  noInitZoneFillLayer,
  noInitZoneOutlineLayer,
} from '@components/map/layers/zones/zone.layer';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectZonesFeatures } from '@redux/config/config.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

function ZoneLayer() {
  const zoneFeatures = useSelectorWithMapId(selectZonesFeatures);

  if (!isFeatureCollection(zoneFeatures)) return null;

  return (
    <Source id={SourceNameEnum.ZONES} type="geojson" data={zoneFeatures} promoteId="featureId">
      <Layer {...noInitZoneFillLayer} />
      <Layer {...noInitZoneOutlineLayer} />
      <Layer {...noFlyZoneFillLayer} />
      <Layer {...noFlyZoneOutlineLayer} />
      <Layer {...initializationMaskingZoneFillLayer} />
      <Layer {...initializationMaskingZoneOutlineLayer} />
      <Layer {...initializationMaskingZoneMarginLayer} />
      <Layer {...initializationMaskingZoneMarginOutlineLayer} />
    </Source>
  );
}

export default ZoneLayer;
